import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=da1426ce"
import script from "./MessageListItem.vue?vue&type=script&lang=js"
export * from "./MessageListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports